import { PropsWithChildren } from 'react'
import { useSelector } from 'react-redux'
import { IdentityProvider } from '@vp/ubik-context'

import { getLocaleSelector } from '~/app/store/config'
import { createAuthConfig } from '~/app/features/FragmentRoot/utils/getAuthConfig'

export const IdentityProviderWrapper = ({ children }: PropsWithChildren) => {
  const locale = useSelector(getLocaleSelector)

  return <IdentityProvider auth={createAuthConfig(locale)}>{children}</IdentityProvider>
}
